import { RefObject, useMemo } from 'react';

import { Margin, Measurement } from '@components/patterns/LineChart/types';
import { useMargin } from '@components/patterns/LineChart/use-margin';

import { useElementSize } from '@hooks/use-element-size';

export function useMeasure(
  ref: RefObject<SVGSVGElement>,
  defaultMargins?: Partial<Margin>
): Measurement {
  const size = useElementSize(ref);

  // Resize observer to update margins of the chart
  const margin = useMargin(ref, defaultMargins);

  return useMemo(
    () => ({
      // Size
      width: size.width,
      height: size.height,
      // Margin
      marginLeft: margin.left,
      marginRight: margin.right,
      marginTop: margin.top,
      marginBottom: margin.bottom,
      // Inner Size
      innerWidth: Math.max(0, size.width - margin.left - margin.right),
      innerHeight: Math.max(0, size.height - margin.top - margin.bottom),
    }),
    [size, margin]
  );
}
